import React from "react";

const Testimonials = () => {
  return (
    <section id="testimonials" className="container px-8 py-16 mx-auto">
      <h2 className="text-3xl font-bold text-center text-gray-900">
        Why Dental Professionals Love EzzyDental
      </h2>
      <p className="mt-4 text-lg text-center text-gray-700">
        See why dentists and practice managers trust VYX Dental for their operations.
      </p>
      <div className="grid gap-8 mt-8 md:grid-cols-3">
        <div className="p-6 text-center bg-white rounded-lg shadow-lg">
          <img src="/assets/testimonial-1.png" alt="Client 1" className="w-20 h-20 mx-auto rounded-full" />
          <h3 className="mt-4 text-xl font-bold text-indigo-600">Dr. Emily Carter</h3>
          <p className="mt-2 italic text-gray-700">
            “VYX Dental transformed how we manage appointments and billing. The cloud access is a game-changer!”
          </p>
        </div>
        <div className="p-6 text-center bg-white rounded-lg shadow-lg">
          <img src="/assets/testimonial-2.png" alt="Client 2" className="w-20 h-20 mx-auto rounded-full" />
          <h3 className="mt-4 text-xl font-bold text-indigo-600">Dr. Michael Roberts</h3>
          <p className="mt-2 italic text-gray-700">
            “I love how intuitive the platform is. My team adapted quickly, and patient experience has improved!”
          </p>
        </div>
        <div className="p-6 text-center bg-white rounded-lg shadow-lg">
          <img src="/assets/testimonial-3.png" alt="Client 3" className="w-20 h-20 mx-auto rounded-full" />
          <h3 className="mt-4 text-xl font-bold text-indigo-600">Dr. Sophia Lee</h3>
          <p className="mt-2 italic text-gray-700">
            “Highly recommend VYX Dental! It's secure, fast, and integrates seamlessly with my workflow.”
          </p>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
